import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import { Add, Remove } from '@mui/icons-material';
import { fetchImage } from '../../actions';
import { productData } from '../../events/sharedSignals';
import { CurrencyShekel } from 'tabler-icons-react';
import IItem from "../../../../../types/product_delivery";
import Product from "../../../../../types/product";
import {roundDecimals} from "../../../../../fromKotlin/nkutils";
import Product_delivery from "../../../../../types/product_delivery";
import {InputAdornment} from "@mui/material";



interface ICustomerProductsSingleRowProps {
    data: Array<IItem>;
    setData: (product: IItem) => void;
}

const MobileDeliverySummarySingleRow: React.FC<ICustomerProductsSingleRowProps> = ({ data,setData }) => {



    const [withDiscount, setWithDiscount] = React.useState<boolean>(parseInt(localStorage.getItem('withDiscount') ?? '0') == 1);
    const handleAmountChange = (p:Product_delivery, increment: boolean,value?:number) => {
        setData({
            ...p,
            quantity: Math.max(0,value ? value : p.quantity + (increment ? 1 : -1))
        })
    };

    const handlePriceChange = (p:Product_delivery, price: number) => {
        setData({
            ...p,
            totalPrice:  Math.max(0,roundDecimals(price,4))
        })
    };

    return (
        <>
            {data.map((product) => (
                <Box
                    key={product.name}
                    sx={{
                        display: 'flex',
                        width: '100%',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '8px',
                        boxShadow: 1,
                        backgroundColor: 'grey.100',
                        borderBottom: '0.5px solid grey'
                    }}
                >
                    <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%', gap: '8px', alignItems: 'center' }}>
                        {/* Product Image */}
                        {/*<Box*/}
                        {/*    component="img"*/}
                        {/*    src={fetchImage(product)}*/}
                        {/*    alt={product.name}*/}
                        {/*    sx={{*/}
                        {/*        width: 50,*/}
                        {/*        height: 50,*/}
                        {/*        borderRadius: '8px',*/}
                        {/*        objectFit: 'cover'*/}
                        {/*    }}*/}
                        {/*/>*/}

                        {/* Product Details */}
                        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', lineHeight: '15px' }}>
                            <Box sx={{ fontWeight: 'bold', fontSize: '16px', color: 'black' }}>{product.name}</Box>
                            <Box component="p" sx={{ fontSize: '11px', color: 'black.300', margin: 0 }}>
                                {product.barcode}
                            </Box>
                        </Box>

                        <Box sx={{ display: 'flex', marginRight: 'auto', fontSize: '10px', fontWeight: 200, padding: '3px 0px 20px 3px' }}>
                            {product.category}
                        </Box>
                    </Box>

                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            margin: 'auto',
                            gap: '20px',
                            padding: '0px 0px 15px 0px'
                        }}
                    >
                        {/* Amount Control */}
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <IconButton
                                sx={{
                                    borderRadius: '50%',
                                    border: '2px solid #ccc',
                                    width: 32,
                                    height: 32,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                                size="small"
                                onClick={() => handleAmountChange(product, false)}
                            >
                                <Remove />
                            </IconButton>
                            <TextField
                                type="number"
                                placeholder={'0'}
                                variant="standard"
                                size="small"
                                sx={{ maxWidth: '50px', textAlign: 'center', margin: 'auto' }}
                                value={product?.quantity || ''}
                                onChange={(e) => handleAmountChange(product, false, parseFloat(e.target.value) || 0)}
                                inputProps={{
                                    min: 0,
                                    style: { textAlign: 'center' } // Ensure text is centered
                                }}
                            />
                            <IconButton
                                sx={{
                                    borderRadius: '50%',
                                    border: '2px solid #ccc',
                                    width: 32,
                                    height: 32,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                                size="small"
                                onClick={() => handleAmountChange(product, true)}
                            >
                                <Add />
                            </IconButton>
                        </Box>

                        {/* Price Input */}
                        <TextField
                            type="number"
                            variant="standard"
                            size="small"
                            sx={{ maxWidth: '80px' }} // Increased width
                            value={product.totalPrice || ''}
                            onChange={(e) => handlePriceChange(product, parseFloat(e.target.value) || 0)}
                            placeholder={product.totalPrice ? product.totalPrice.toString() : '0'}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <CurrencyShekel size={16} />
                                    </InputAdornment>
                                )
                            }}
                            onFocus={(e) => e.target.select()} // Select all text when focused
                        />

                        {/* Discount Input (if withDiscount is true) */}
                        {withDiscount && (
                            <TextField
                                type="number"
                                variant="standard"
                                size="small"
                                sx={{ maxWidth: '50px' }} // Increased width
                                value={product.discount || ''}
                                onChange={(e) => setData({ ...product, discount: Math.max(0, Math.min(100, parseFloat(e.target.value) || 0)) })}
                                placeholder={product.discount ? product.discount.toString() : '0'}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">%</InputAdornment>
                                    )
                                }}
                                onFocus={(e) => e.target.select()} // Select all text when focused
                            />
                        )}


                    </Box>
                </Box>
            ))}
        </>
    );
};

export default MobileDeliverySummarySingleRow;
